import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountService } from '@wilson/account';
import { UserOvertime } from '@wilson/interfaces';
import { DateTimeFormat, generateMonthsForYear } from '@wilson/utils';
import { format } from 'date-fns';
import { BehaviorSubject, combineLatest, EMPTY } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WorkTimeManagementStoreService {
  private readonly store = inject(Store);
  private readonly accountService = inject(AccountService);

  private overtimeMonthsBalance = new BehaviorSubject<
    UserOvertime | null | 'empty'
  >('empty');

  get overtimeMonthsBalance$() {
    return this.overtimeMonthsBalance.asObservable();
  }

  getOvertimeMonthsBalance(selectedYear: BehaviorSubject<number>) {
    this.overtimeMonthsBalance.next(null);

    combineLatest([
      this.store
        .select((state) => state.auth.userId)
        .pipe(filter((userId) => userId != null)),
      selectedYear,
    ])
      .pipe(
        switchMap(([userId, year]) =>
          this.accountService
            .getUserOvertimes(
              generateMonthsForYear(year).map((range) => ({
                start: format(
                  new Date(range.start),
                  DateTimeFormat.DatabaseDateFormat,
                ),
                end: format(
                  new Date(range.end),
                  DateTimeFormat.DatabaseDateFormat,
                ),
              })),
              { where: { id: userId } },
            )
            .pipe(catchError(() => EMPTY)),
        ),
        map((userOvertimes) =>
          userOvertimes?.length ? userOvertimes[0] : 'empty',
        ),
      )
      .subscribe((UserOvertime) => {
        this.overtimeMonthsBalance.next(UserOvertime);
      });
  }
}
